angular.module( 'acme.view.application.donations.config.settings', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.donations.config.settings.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var donationsConfigSettings = {
        name: 'application.donations.config.settings',
        url: '/settings',
        views: {
          "subview-main": {
            controller: 'DonationsConfigSettingsController',
            templateUrl: 'views/application/views/donations/config/settings/settings.tpl.html'
          }
        },
        data: {
          pageTitle: 'Form settings'
        }
      };

    $stateProvider
      .state(donationsConfigSettings);
});
